import { createSlice } from '@reduxjs/toolkit'

export const dynamicBgColorSlice = createSlice({
  name: 'dynamicBgColor',
  initialState: {
    dynamicBgColor: '#bec6f4'
  },
  reducers: {
    setDynamicBgColor(state, action) {
      state.dynamicBgColor = action.payload
    },
    initializeDynamicBgColor(state, action) {
      state.dynamicBgColor = '#bec6f4'
    }
  }
})

export const {
  setDynamicBgColor,
  initializeDynamicBgColor
} = dynamicBgColorSlice.actions
export default dynamicBgColorSlice.reducer